import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Divider } from "@material-ui/core";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AddBatchDialog = ({
  addBatchModal,
  setAddBatchModal,
  handleCloseDialog,
  courseId,
  courseName,
}) => {
  const [batchType, setBatchType] = useState("");
  const { data } = useSelector((state) => state?.batchOveriew);

  const navigate = useNavigate();

  const handleChange = (event) => {
    setBatchType(event.target.value);
  };

  const handleCancel = () => {
    setBatchType("");
    setAddBatchModal(false);
  };

  const handleSelectBatchType = () => {
    {
      batchType === "Live"
        ? navigate("/batch/batchesoverview/add-batch", {
            state: {
              course: data,
              courseId: courseId,
              courseName: courseName,
            },
          })
        : navigate("/batch/batchesoverview/add-self-batch", {
            state: {
              course: data,
              courseId: courseId,
              courseName: courseName,
            },
          });
    }
  };

  return (
    <div>
      <Dialog
        maxWidth="md"
        className="enroll_subAdmin"
        open={addBatchModal}
        onClose={handleCloseDialog}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #E6E6E6",
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "1.6rem",
            divider: false, // Remove the default divider
          }}
        >
          <h1 style={{ fontSize: "1.5rem", fontWeight: "700" }}>
            Select Batch Type
          </h1>
          <CloseIcon onClick={handleCloseDialog} sx={{ cursor: "pointer" }} />
        </DialogTitle>
        <DialogContent style={{ width: "800px", overflow: "hidden" }} dividers>
          <Box>
            <Box>
              <FormControl sx={{ m: 1, width: "97%" }}>
                <InputLabel id="demo-simple-select-label">
                  Batch Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={batchType}
                  onChange={handleChange}
                >
                  <MenuItem value={"Live"}>Live Batch</MenuItem>
                  <MenuItem value={"Self"}>Self Batch</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        </DialogContent>
        <Divider />
        <Box
          className="flex justify-between"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "1rem 1.5rem",
          }}
        >
          <Box>
            <Button
              sx={{
                fontWeight: "600",
                lineHeight: "100%",
                color: "#333",
                padding: "0.65rem",
                marginRight: "1rem",
              }}
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              disabled={batchType.length === 0}
              variant="contained"
              sx={{
                backgroundColor: "#8DADFD",
                borderRadius: "0.5rem",
                lineHeight: "100%",
                color: "white",
                padding: "0.65rem",
              }}
              onClick={handleSelectBatchType}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Dialog>
    </div>
  );
};

export default AddBatchDialog;
